var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { StyledButtonExtend } from './style';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        return _super.call(this, props) || this;
    }
    Button.prototype.render = function () {
        return React.createElement(StyledButtonExtend, __assign({}, this.props));
    };
    Button.propTypes = {
        cover: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        coverType: PropTypes.string,
        danger: PropTypes.bool,
        fullWidth: PropTypes.bool,
        icon: PropTypes.bool,
        upload: PropTypes.bool,
        primary: PropTypes.bool,
        mini: PropTypes.bool,
    };
    return Button;
}(React.Component));
export default Button;
//# sourceMappingURL=index.js.map